var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5858 0H1.41421C0.523309 0 0.07714 1.07714 0.707105 1.7071L7.29289 8.29289C7.68342 8.68342 8.31658 8.68342 8.70711 8.29289L15.2929 1.70711C15.9229 1.07714 15.4767 0 14.5858 0Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSecondary);
export default __webpack_public_path__ + "static/media/ArrowDownSecondary.f89811d8fbd0957d7d7a3b2756d5e292.svg";
export { ForwardRef as ReactComponent };